import APIFetcher from '../APIFetcher';

class HeroArticleHeaderApi {
  static get() {
    return APIFetcher.get('hero-article-header');
  }
}

export default HeroArticleHeaderApi;
